import { render, staticRenderFns } from "./seeArchives.vue?vue&type=template&id=438e9e3a&scoped=true&"
import script from "./seeArchives.vue?vue&type=script&lang=js&"
export * from "./seeArchives.vue?vue&type=script&lang=js&"
import style0 from "./seeArchives.vue?vue&type=style&index=0&id=438e9e3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e9e3a",
  null
  
)

export default component.exports